var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "callact-main", style: `padding-top:${_vm.barHeight}px` },
    [
      _c("van-nav-bar", {
        staticClass: "van-bar",
        attrs: { "left-arrow": "" },
        on: { "click-left": _vm.closeWeb },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("img", {
                  staticClass: "left-nav",
                  attrs: { src: require("./images/c-left-arrow.png"), alt: "" },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "right",
            fn: function () {
              return [
                _c(
                  "span",
                  { staticClass: "tit-right", on: { click: _vm.handleToRule } },
                  [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("./images/c-question.png"),
                        alt: "",
                      },
                    }),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        {
          staticClass: "callact-head",
          style: { "margin-top": `-${_vm.barHeight * 1 + 46}px` },
        },
        [
          _c("img", {
            staticClass: "top-bg",
            attrs: { src: require("./images/top-bg.png") },
          }),
          _vm.$i18n.locale == "ar"
            ? _c("img", {
                staticClass: "top-tit",
                attrs: { src: _vm.getMatchTitle("bg-ar") },
              })
            : _vm.$i18n.locale == "es"
            ? _c("img", {
                staticClass: "top-tit",
                attrs: { src: _vm.getMatchTitle("bg-es") },
              })
            : _vm.$i18n.locale == "fr"
            ? _c("img", {
                staticClass: "top-tit",
                attrs: { src: _vm.getMatchTitle("bg-fr") },
              })
            : _vm.$i18n.locale == "id"
            ? _c("img", {
                staticClass: "top-tit",
                attrs: { src: _vm.getMatchTitle("bg-id") },
              })
            : _vm.$i18n.locale == "pt"
            ? _c("img", {
                staticClass: "top-tit",
                attrs: { src: _vm.getMatchTitle("bg-pt") },
              })
            : _vm.$i18n.locale == "tr"
            ? _c("img", {
                staticClass: "top-tit",
                attrs: { src: _vm.getMatchTitle("bg-tr") },
              })
            : _c("img", {
                staticClass: "top-tit",
                attrs: { src: _vm.getMatchTitle("bg-en") },
              }),
          _vm.actInfo && _vm.actInfo.weekTask
            ? [
                _vm.actInfo.weekTask.state !== 2
                  ? _c("img", {
                      staticClass: "top-box",
                      attrs: { src: _vm.getMatchTitle("box-close") },
                    })
                  : _vm._e(),
                _vm.actInfo.weekTask.state === 2
                  ? _c("img", {
                      staticClass: "top-box",
                      attrs: { src: _vm.getMatchTitle("box-open") },
                    })
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("div", { staticClass: "callact-con" }, [
        _c("div", { staticClass: "callact-relcon" }, [
          _c("div", { staticClass: "act-date-block" }, [
            _c("div", { staticClass: "rect-bar-block" }, [
              _c("div", { staticClass: "percent-block" }, [
                _vm.actInfo
                  ? _c("div", { staticClass: "percent-bar" }, [
                      _vm.actInfo.percent > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "percent-track",
                              style: { width: `${_vm.actInfo.percent}%` },
                            },
                            [
                              _vm._v(" " + _vm._s(_vm.actInfo.coins) + " "),
                              _c("img", {
                                attrs: {
                                  src: _vm.getMatchImg("coin"),
                                  alt: "",
                                },
                              }),
                              _vm.actInfo.weekTask
                                ? _c("div", { staticClass: "max-tips" }, [
                                    _vm.actInfo.weekTask.state !== 2 &&
                                    _vm.actInfo.coins === _vm.actInfo.max
                                      ? _c(
                                          "div",
                                          { staticClass: "max-tips-con1" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("lang.commonM.k299")
                                                )
                                              ),
                                            ]),
                                            _c("img", {
                                              attrs: {
                                                src: require("./images/rect-tips-mid.png"),
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.actInfo.weekTask.state === 2
                                      ? _c(
                                          "div",
                                          { staticClass: "max-tips-con2" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("lang.commonM.k300")
                                                )
                                              ),
                                            ]),
                                            _c("img", {
                                              attrs: {
                                                src: require("./images/rect-tips-long.png"),
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "percent-gap" }),
                _vm.actInfo
                  ? _c("span", { staticClass: "percent-num" }, [
                      _vm._v(" " + _vm._s(_vm.$t("lang.intimate.max")) + " "),
                      _c("i", { staticStyle: { "font-weight": "500" } }, [
                        _vm._v(_vm._s(_vm.actInfo.max)),
                      ]),
                    ])
                  : _vm._e(),
                _c("img", {
                  staticClass: "key-icon",
                  attrs: { src: require("./images/key-icon.png") },
                }),
              ]),
              _c("div", { staticClass: "bar-tips" }, [
                _vm._v(_vm._s(_vm.$rt("lang.commonM.k290"))),
              ]),
            ]),
            _c("img", {
              staticClass: "rect-bg",
              attrs: { src: require("./images/rect-bg.png") },
            }),
            _c("div", { staticClass: "date-block" }, [
              _c("div", { staticClass: "end-txt" }, [
                _vm._v(_vm._s(_vm.$t("lang.commonM.k206"))),
              ]),
              _c("div", { staticClass: "date-con" }, [
                _c("div", { staticClass: "date-item" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.countdownResult.days || "00")),
                  ]),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.day"))),
                  ]),
                ]),
                _c("div", { staticClass: "date-step" }),
                _c("div", { staticClass: "date-item" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.countdownResult.hours || "00")),
                  ]),
                  _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k261")))]),
                ]),
                _c("div", { staticClass: "date-step" }),
                _c("div", { staticClass: "date-item" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.countdownResult.minutes || "00")),
                  ]),
                  _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k262")))]),
                ]),
                _c("div", { staticClass: "date-step" }),
                _c("div", { staticClass: "date-item" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.countdownResult.seconds || "00")),
                  ]),
                  _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k263")))]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "part-block" }, [
            _c("div", { staticClass: "part-head part-head1" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k225"))),
            ]),
            _c("div", { staticClass: "part-tips" }, [
              _vm._v(_vm._s(_vm.$rt("lang.commonM.k264"))),
            ]),
            _vm.actInfo && _vm.actInfo.signTask
              ? _c("div", { staticClass: "task-item" }, [
                  _c("img", {
                    staticClass: "task-icon",
                    attrs: { src: require("./images/date.png") },
                  }),
                  _c("div", { staticClass: "gap-ele" }),
                  _c("div", { staticClass: "task-txt" }, [
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("lang.commonM.k265")) +
                          " (" +
                          _vm._s(_vm.actInfo.signTask.proc) +
                          "/" +
                          _vm._s(_vm.actInfo.signTask.target) +
                          ")"
                      ),
                    ]),
                    _c("div", { staticClass: "ar-num" }, [
                      _c("img", { attrs: { src: _vm.getMatchImg("coin") } }),
                      _vm._v(
                        " +3 " + _vm._s(_vm.$t("lang.commonM.k266")) + " "
                      ),
                    ]),
                  ]),
                  _vm.actInfo.signTask.state == 0
                    ? _c(
                        "div",
                        {
                          staticClass: "task-btn active",
                          on: { click: _vm.handleSign },
                        },
                        [_vm._v(_vm._s(_vm.$t("lang.commonM.k293")))]
                      )
                    : _vm._e(),
                  _vm.actInfo.signTask.state == 1
                    ? _c(
                        "div",
                        { staticClass: "task-btn" },
                        [
                          _vm.leftClassObj && _vm.leftClassObj.countdownResult
                            ? [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.leftClassObj.countdownResult.hours
                                    ) +
                                    ":" +
                                    _vm._s(
                                      _vm.leftClassObj.countdownResult.minutes
                                    ) +
                                    ":" +
                                    _vm._s(
                                      _vm.leftClassObj.countdownResult.seconds
                                    ) +
                                    " "
                                ),
                              ]
                            : [_vm._v("00:00:00")],
                        ],
                        2
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.actInfo && _vm.actInfo.callTask
              ? _c("div", { staticClass: "task-item" }, [
                  _c("img", {
                    staticClass: "task-icon",
                    attrs: { src: require("./images/call.png") },
                  }),
                  _c("div", { staticClass: "gap-ele" }),
                  _c("div", { staticClass: "task-txt" }, [
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.$t("lang.commonM.k267")) +
                          " (" +
                          _vm._s(_vm.actInfo.callTask.proc) +
                          "/" +
                          _vm._s(_vm.actInfo.callTask.target) +
                          ")"
                      ),
                    ]),
                    _c("div", { staticClass: "ar-num" }, [
                      _c("img", { attrs: { src: _vm.getMatchImg("coin") } }),
                      _vm._v(
                        " +10 " + _vm._s(_vm.$t("lang.commonM.k266")) + " "
                      ),
                    ]),
                  ]),
                  _vm.actInfo.callTask.state == 0
                    ? _c(
                        "div",
                        {
                          staticClass: "task-btn active",
                          on: { click: _vm.handleToClient },
                        },
                        [_vm._v(_vm._s(_vm.$t("lang.commonM.k273")))]
                      )
                    : _vm._e(),
                  _vm.actInfo.callTask.state == 1
                    ? _c(
                        "div",
                        { staticClass: "task-btn" },
                        [
                          _vm.leftClassObj && _vm.leftClassObj.countdownResult
                            ? [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.leftClassObj.countdownResult.hours
                                    ) +
                                    ":" +
                                    _vm._s(
                                      _vm.leftClassObj.countdownResult.minutes
                                    ) +
                                    ":" +
                                    _vm._s(
                                      _vm.leftClassObj.countdownResult.seconds
                                    ) +
                                    " "
                                ),
                              ]
                            : [_vm._v("00:00:00")],
                        ],
                        2
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "part-block" }, [
            _c("div", { staticClass: "part-head part-head1" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k268"))),
            ]),
            _vm.actInfo && _vm.actInfo.unit === 1
              ? _c("div", { staticClass: "part-tips" }, [
                  _vm._v(_vm._s(_vm.$rt("lang.commonM.k380"))),
                ])
              : _c("div", { staticClass: "part-tips" }, [
                  _vm._v(_vm._s(_vm.$rt("lang.commonM.k269"))),
                ]),
            _vm.actInfo
              ? _c("div", { staticClass: "task-card" }, [
                  _c("div", { staticClass: "card-item" }, [
                    _c("div", { staticClass: "card-item-count" }, [
                      _vm._v(" " + _vm._s(_vm.actInfo.calls) + " "),
                      _c("div", { staticStyle: { width: "4px" } }),
                      _c("i", [_vm._v(_vm._s(_vm.$t("lang.task.calls")))]),
                    ]),
                    _vm.actInfo && _vm.actInfo.unit === 1
                      ? _c("div", { staticClass: "card-item-txt" }, [
                          _vm._v(_vm._s(_vm.$t("lang.commonM.k381"))),
                        ])
                      : _c("div", { staticClass: "card-item-txt" }, [
                          _vm._v(_vm._s(_vm.$t("lang.commonM.k270"))),
                        ]),
                  ]),
                  _c("div", { staticStyle: { width: "12px" } }),
                  _c("div", { staticClass: "card-item" }, [
                    _c("div", { staticClass: "card-item-count" }, [
                      _vm._v(" " + _vm._s(_vm.actInfo.refunded) + " "),
                      _c("div", { staticStyle: { width: "4px" } }),
                      _c("img", { attrs: { src: _vm.getMatchImg("coin") } }),
                    ]),
                    _c("div", { staticClass: "card-item-txt" }, [
                      _vm._v(_vm._s(_vm.$t("lang.commonM.k271"))),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "task-item" },
              [
                _c("img", {
                  staticClass: "task-icon",
                  attrs: { src: require("./images/camera.png") },
                }),
                _c("div", { staticClass: "gap-ele" }),
                _c("div", { staticClass: "task-txt" }, [
                  _vm.actInfo && _vm.actInfo.unit === 1
                    ? _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k382")))])
                    : _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k272")))]),
                  _c("div", { staticClass: "ar-num" }, [
                    _c("img", { attrs: { src: _vm.getMatchImg("coin") } }),
                    _vm._v(
                      " +10% " + _vm._s(_vm.$t("lang.commonM.k296")) + " "
                    ),
                  ]),
                ]),
                _vm.actInfo && _vm.actInfo.weekTask
                  ? [
                      _vm.actInfo.weekTask.state !== 2
                        ? _c(
                            "div",
                            {
                              staticClass: "task-btn active",
                              on: { click: _vm.handleToClient },
                            },
                            [_vm._v(_vm._s(_vm.$t("lang.commonM.k273")))]
                          )
                        : _c("div", { staticClass: "task-btn" }, [
                            _vm._v(_vm._s(_vm.$t("lang.commonM.k074"))),
                          ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _c("div", { staticClass: "part-block" }, [
            _c("div", { staticClass: "part-head part-head2" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k274"))),
            ]),
            _vm.actInfo && _vm.actInfo.unit === 1
              ? _c("div", { staticClass: "part-tips" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k417"))),
                ])
              : _c("div", { staticClass: "part-tips" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k275"))),
                ]),
            _c("div", { staticClass: "get-key-block" }, [
              _c("div", { staticClass: "key-bar" }, [
                _c("img", {
                  staticClass: "key-clock",
                  attrs: { src: require("./images/clock.png") },
                }),
                _c("div", { staticClass: "key-bar-bg" }, [
                  _vm.actInfo && _vm.actInfo.weekTask
                    ? _c("div", { staticClass: "key-percent" }, [
                        _vm.actInfo.weekTask.percent > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "key-track",
                                style: {
                                  width: `${_vm.actInfo.weekTask.percent}%`,
                                },
                              },
                              [
                                _c("div", { staticClass: "key-track-tips" }, [
                                  _c("div", [
                                    _c("img", {
                                      attrs: {
                                        src: require("./images/rect-tips.png"),
                                      },
                                    }),
                                    _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.actInfo.weekTask.proc) +
                                          " "
                                      ),
                                      _vm.actInfo && _vm.actInfo.unit === 1
                                        ? _c("i", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("lang.commonM.k366")
                                              )
                                            ),
                                          ])
                                        : _c("i", [
                                            _vm._v(
                                              _vm._s(_vm.$t("lang.host.min"))
                                            ),
                                          ]),
                                    ]),
                                  ]),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
                _c("img", {
                  staticClass: "key-right",
                  attrs: { src: require("./images/key-r.png") },
                }),
              ]),
              _vm.actInfo && _vm.actInfo.weekTask
                ? _c("div", { staticClass: "key-tips" }, [
                    _c("div", { staticClass: "tips-left" }, [
                      _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k276")) + ": "),
                      _c("i", [
                        _vm._v(_vm._s(_vm.actInfo.weekTask.target || 0)),
                      ]),
                      _vm.actInfo && _vm.actInfo.unit === 1
                        ? _c("i", [_vm._v("dtk")])
                        : _c("i", [_vm._v(_vm._s(_vm.$t("lang.host.min")))]),
                    ]),
                    _c("div", { staticClass: "tips-right" }, [
                      _vm._v(" " + _vm._s(_vm.$t("lang.beer.left")) + ": "),
                      _c("i", [_vm._v(_vm._s(_vm.actInfo.weekTask.left || 0))]),
                      _vm.actInfo && _vm.actInfo.unit === 1
                        ? _c("i", [_vm._v("dtk")])
                        : _c("i", [_vm._v(_vm._s(_vm.$t("lang.host.min")))]),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "get-key-tips" }, [
                _c("img", { attrs: { src: require("./images/tips.png") } }),
                _vm.actInfo && _vm.actInfo.unit === 1
                  ? _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k414")))])
                  : _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k298")))]),
              ]),
            ]),
          ]),
          _vm.actInfo && _vm.actInfo.weekTask
            ? _c("div", { staticClass: "callact-btn-block" }, [
                _vm.actInfo.weekTask.state === 0
                  ? _c("div", { staticClass: "callact-btn" }, [
                      _vm._v(_vm._s(_vm.$t("lang.commonM.k291"))),
                    ])
                  : _vm._e(),
                _vm.actInfo.weekTask.state === 1
                  ? _c(
                      "div",
                      {
                        staticClass: "callact-btn callact-btn-active",
                        on: { click: _vm.handleClaim },
                      },
                      [_vm._v(_vm._s(_vm.$rt("lang.commonM.k292")))]
                    )
                  : _vm._e(),
                _vm.actInfo.weekTask.state === 2
                  ? _c("div", { staticClass: "callact-btn" }, [
                      _vm._v(_vm._s(_vm.$t("lang.commonM.k074"))),
                    ])
                  : _vm._e(),
                _c("div", { style: { height: `${_vm.bottomBarHeight}px` } }),
              ])
            : _vm._e(),
        ]),
        _vm.showSuccess
          ? _c("div", { staticClass: "act-mask" }, [
              _c("div", { staticClass: "dia-con" }, [
                _c("img", { attrs: { src: _vm.getMatchImg("many-coins") } }),
                _c("div", { staticClass: "dia-main" }, [
                  _c("div", { staticClass: "dia-tit" }, [
                    _c("div", { staticClass: "dia-tit-left" }),
                    _c("div", { staticClass: "dia-tit-txt" }, [
                      _vm._v(_vm._s(_vm.$t("lang.commonM.k147"))),
                    ]),
                    _c("div", { staticClass: "dia-tit-right" }),
                  ]),
                  _c("div", { staticClass: "dia-txt" }, [
                    _c("img", { attrs: { src: require("./images/X.png") } }),
                    _vm._v(" " + _vm._s(_vm.rewardCoins) + " "),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "dia-btn",
                      on: {
                        click: function ($event) {
                          _vm.showSuccess = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("lang.ok")))]
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }